import heading_city from "../Assets/img/illustrastions/heading_city.png";
import heading_city_bg from "../Assets/img/illustrastions/heading_city2.png";

const BoxHeader = ({title, text}) => {
    return (
        <div data-aos="fade-up" data-aos-delay="50" className="box-header relative text-white rounded-md py-12 px-8 h-auto">
            <img src={heading_city} alt="bg" className="absolute bottom-0 right-0 opacity-60" />
            <img src={heading_city_bg} alt="bg" className="absolute bottom-0 right-0 opacity-60" />
            <div className="py-3 w-full md:w-96">
                <h1 data-aos="fade-up" data-aos-delay="150" className="text-2xl sm:text-3xl font-semibold py-2">{title}</h1>
                <p data-aos="fade-up" data-aos-delay="150" className="text-sm font-medium">
                    {text}
                </p>
            </div>
        </div>
    )
}

export default BoxHeader